/**
 * Shared language → color map for language dots (repo cards, repo header) and the
 * Explore org-tile language bars. Values follow GitHub linguist's palette so the
 * indicators read the same as on the upstream Git host. Languages outside the map
 * fall back to a neutral gray.
 */
export const languageColors: Record<string, string> = {
  TypeScript: '#3178c6',
  JavaScript: '#f1e05a',
  Rust: '#dea584',
  Go: '#00add8',
  Python: '#3572a5',
  Shell: '#89e051',
  HTML: '#e34c26',
  CSS: '#563d7c',
  SCSS: '#c6538c',
  Less: '#1d365d',
  Vue: '#41b883',
  Svelte: '#ff3e00',
  Astro: '#ff5a03',
  Dockerfile: '#384d54',
  Markdown: '#083fa1',
  JSON: '#292929',
  YAML: '#cb171e',
  TOML: '#9c4221',
  XSLT: '#eb8ceb',
  XML: '#0060ac',
  Swift: '#f05138',
  'Objective-C': '#438eff',
  C: '#555555',
  'C++': '#f34b7d',
  'C#': '#178600',
  Java: '#b07219',
  Kotlin: '#a97bff',
  Ruby: '#701516',
  PHP: '#4f5d95',
  Scala: '#c22d40',
  Elixir: '#6e4a7e',
  Erlang: '#b83998',
  Haskell: '#5e5086',
  Clojure: '#db5855',
  Lua: '#000080',
  Perl: '#0298c3',
  Dart: '#00b4ab',
  Zig: '#ec915c',
  Nix: '#7e7eff',
  HCL: '#844fba',
  PowerShell: '#012456',
  Makefile: '#427819',
  CMake: '#da3434',
  TeX: '#3d6117',
  R: '#198ce7',
  Vim_Script: '#199f4b',
  'Vim Script': '#199f4b',
  'Jupyter Notebook': '#da5b0b',
  GLSL: '#5686a5',
  Solidity: '#aa6746',
};

export const languageColor = (languageArg: string): string =>
  languageColors[languageArg] ?? '#8b949e';
